import dayjs from 'dayjs';

export const Date = ({ date }: any) => {
    if (!date) return <span>-</span>;
    return <span>{dayjs(date).format('DD.MM.YYYY')}</span>;
};
